"use strict";
exports.__esModule = true;
exports.ParserPage = void 0;
var ParserNode_1 = require("./ParserNode");
var ParserNodeList_1 = require("./ParserNodeList");
var PdfParserFinder_1 = require("./PdfParserFinder");
var ParserPage = /** @class */ (function () {
    function ParserPage(page) {
        this.page = page;
    }
    ParserPage.prototype.Find = function (text) {
        var elements = PdfParserFinder_1.PdfParserFinder.FindElementByFromPage(this.page, text);
        return new ParserNode_1.ParserNode(this.page, elements[0]);
    };
    ParserPage.prototype.FindAll = function (text) {
        var _this = this;
        var elements = PdfParserFinder_1.PdfParserFinder.FindElementByFromPage(this.page, text);
        return elements.map(function (item) { return new ParserNode_1.ParserNode(_this.page, item); });
    };
    ParserPage.prototype.WithinRect = function (rect) {
        var _this = this;
        var elements = PdfParserFinder_1.PdfParserFinder.FindElementWithinRectOfPage(this.page, rect.x, rect.y, rect.x2, rect.y2);
        return new ParserNodeList_1.ParserNodeList(this.page, elements.map(function (item) { return new ParserNode_1.ParserNode(_this.page, item); }));
    };
    ParserPage.FromPDFJSON = function (pdfJSON) {
        var mergedPage = PdfParserFinder_1.PdfParserFinder.MergeAllPages(pdfJSON);
        var pages = (pdfJSON === null || pdfJSON === void 0 ? void 0 : pdfJSON.pages.map(function (item) { return new ParserPage(item); })) || [];
        var merged = new ParserPage(mergedPage);
        return {
            pages: pages,
            merged: merged,
            pdfJSON: pdfJSON
        };
    };
    return ParserPage;
}());
exports.ParserPage = ParserPage;
//# sourceMappingURL=ParserPage.js.map